import React, { useEffect, useState } from 'react';
import Grid from '../../../Grid';
import styles from './Cards.module.sass';

const OtherItemsCards = () => {
  const [counts, setCounts] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      let response = await fetch('/api/v1/orders/order_package_counts_other_items')
      response = await response.json()
      setCounts(response.data)
    }

    fetchPackages();
  }, [])

  const handleClick = (e) => {
    e.preventDefault();

    const orderOlderThan = $('#export_order_older_than').val();
    const exportType = $('#export_type').val();
    const includeImages = $('#include_images').is(':checked');
    const href = $(e.target).attr('href');

    window.open(`${href}&order_older_than=${orderOlderThan}&export_type=${exportType}&include_images=${includeImages}`)
  }

  return (
    <div className={styles.cardsContainer}>
      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=other_items&mark_as_exported=true"
             onClick={handleClick}>
            {counts && counts.ready_for_export}
          </a>
          <p className={styles.cardInfo}>
            Items that are ready to be exported
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=other_items_not_shipped"
             onClick={handleClick}>
            {counts && counts.not_yet_shipped}
          </a>
          <p className={styles.cardInfo}>
            Items that have been exported but not shipped
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=shipped_24_hours"
             onClick={handleClick}>
            {counts && counts.shipped_24_hours}
          </a>
          <p className={styles.cardInfo}>
            Items that have been shipped in the last 24 hours
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=reprint&scope=other_exportable_items"
             onClick={handleClick}>
            {counts && counts.reprint}
          </a>
          <p className={styles.cardInfo}>
            Items marked as reprint
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=on_hold&scope=other_exportable_items"
             onClick={handleClick}>
            {counts && counts.on_hold}
          </a>
          <p className={styles.cardInfo}>
            Items on hold
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=work_order_packages&scope=other_exportable_items"
             onClick={handleClick}>
            {counts && counts.work_orders}
          </a>
          <p className={styles.cardInfo}>
            Work orders ready to print
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default OtherItemsCards
